// extracted by mini-css-extract-plugin
export default {"logo":"LogoWithText__logo--66f9k3","header":"LogoWithText__header--RYsn9M","subtitle":"LogoWithText__subtitle--AjdUTa"};